import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { NotesApi } from "../../../../../apis/notes.api";

@autoinject
@transient()
export class DialogConfirmDeleteDocument {

    private _noteId: number;
    private onDelete: () => void;

    constructor(public dialogClientService: DialogClientService, private notesApi: NotesApi, 
        private notificationClientService: NotificationClientService) {}

    activate(model: { noteId, onDelete: () => void }) {
        this._noteId = model.noteId;
        this.onDelete = model.onDelete;
    }

    //Delete
    public async delete() {
        try {
            await this.notesApi.deleteNote(this._noteId)
            this.notificationClientService.show("Note deleted successfully", "", NotificationType.Success);
            if(this.onDelete)
                this.onDelete();
            this.dialogClientService.hide(true);
        }
        catch (error) {
            console.error(error);
            this.notificationClientService.show("An error occurd while trying to delete the note", "", NotificationType.Error);
        }
    }

    //Cancel
    public cancel() {
        this.dialogClientService.hide(true);
    }
}